import { Theme } from '@mui/material/styles'

const tourStyles = (theme: Theme) => {
    return {
        popover: (base: object) => ({
            ...base,
            width: 'min(420px, calc(100vw - 24px))',
            maxWidth: '420px',
            boxShadow: '0 14px 42px rgba(16, 49, 66, 0.22)',
        }),
        mask: (base: object) => ({
            ...base,
            backgroundColor: 'rgba(255, 0, 0, 255)',
        }),
        badge: (base: object) => ({
            ...base,
            left: '45%',
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        }),
        close: (base: object) => ({
            ...base,
            color: theme.palette.primary.main,
        }),
        content: (base: object) => ({
            ...base,
            color: theme.palette.primary.main,
        }),
        arrow: (base: object) => ({
            ...base,
            color: theme.palette.primary.main,
        }),
    }
}

export default tourStyles
